export default __webpack_public_path__ + "static/media/atbs-background.d6dd15a8.png";